import { useState, useEffect } from 'react'
import { DatePickerFormComponent } from '@/modules/shared/components/date-picker-form.component'
import { InputFormComponent } from '@/modules/shared/components/input-form.component'
import { SelectFormComponent } from '@/modules/shared/components/select-form.component'
import {
	Form
} from '@/modules/shared/components/ui/form'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from '@/modules/shared/components/ui/dialog'
import { Button } from '@/modules/shared/components/ui/button'
import { Input } from '@/modules/shared/components/ui/input'
import { type OrderFormData, useOrderDataComponent } from './use-details.hook'
import { useOrderFormStore } from '../../stores/order-form.store'
import { EntityCardComponent } from './entity-card.component'
import { ModalEntityInfiniteScrollComponent } from './selection-modal/modal-entities.component'
import { ModalChangeCustomerComponent } from './selection-modal/modal-confirm-change-customer.component'
import { useEntitySelection } from './selection-modal/use-entity-selection.hook'

export function DetailsComponent() {
	const {
		form,
		isViewOrder,
		hasClientSelected,
		billingType,
		freightType,
		isActiveFieldSelectSeller,
		isEnabledCommission,
		isEnabledShippingType,
		isEnabledBillingType,
		isVisibleCommission,
		isVisibleTransport,
		handleChangeValues,
		operationTypeOrder,
		priceTableList,
		setIsCalculationComissionOrder,
		permiteAlteraDataEmissao
	} = useOrderDataComponent()

	const [isOpenModalNPedido, setIsOpenModalNPedido] = useState(false)
	const [tempNPedido, setTempNPedido] = useState('')

	useEffect(() => {
		if (isOpenModalNPedido) {
			setTempNPedido(form.getValues('nPedidoCliente') || '')
		}
	}, [isOpenModalNPedido, form])

	const handleConfirmNPedido = () => {
		handleChangeValues({ nPedidoCliente: tempNPedido })
		setIsOpenModalNPedido(false)
	}

	const {
		openModal,
		isOpenModalChangeCustomerData,
		handleModalConfirmChangeCustomer,
		handleModalCancelChangeCustomer,
	} = useEntitySelection()

	const {
		jsonOrderForm,
	} = useOrderFormStore()

	const handleOpenModalSearchClient = () => {
		openModal('client')
	}

	const handleOpenModalSearchSeller = () => {
		openModal('seller')
	}

	const handleOpenModalSearchTransport = () => {
		openModal('transport')
	}

	return (
		<>
			<div className="flex-1 space-y-6">
				<Form {...form}>
					<div className='flex gap-6 flex-col md:flex-row'>
						<div className="flex flex-1 w-full md:w-[40%]">
							<EntityCardComponent
								title='Cliente'
								descrpition='Clique para selecionar um cliente'
								onOpen={handleOpenModalSearchClient}
								entity={jsonOrderForm?.cliente}
								disabled={isViewOrder}
							/>
						</div>
						<div className="gap-6 flex flex-col md:flex-col flex-1">
							<DatePickerFormComponent<OrderFormData>
								label="Data de emissão"
								control={form.control}
								disabled={isViewOrder || !hasClientSelected || !permiteAlteraDataEmissao}
								name="dataEmissao"
								onChange={(value) => {
									handleChangeValues({
										dataEmissao: value,
									})
								}}
							/>
							<DatePickerFormComponent<OrderFormData>
								label="Data de entrega"
								control={form.control}
								disabled={isViewOrder || !hasClientSelected}
								name="dataEntrega"
								onChange={(value) => {
									handleChangeValues({
										dataEntrega: value,
									})
								}}
							/>
						</div>
					</div>

					<div className="flex gap-6 flex-col md:flex-row w-full">
						<SelectFormComponent<OrderFormData>
							label="Tipo de operação"
							control={form.control}
							name="fkOperacao"
							disabled={isViewOrder || !hasClientSelected}
							onChange={(value) => {
								handleChangeValues({
									fkOperacao: value,
								})
							}}
							options={operationTypeOrder?.map((param) => ({
								value: param.idOperacao,
								label: param.descricao,
							}))}
						/>

						<SelectFormComponent<OrderFormData>
							label="Tipo de Frete"
							control={form.control}
							name="fkFrete"
							disabled={!isEnabledShippingType || isViewOrder || !hasClientSelected}
							onChange={(value) => {
								handleChangeValues({
									fkFrete: value,
								})
							}}
							options={freightType?.map((param) => ({
								value: param.idFrete.toString(),
								label: param.descricao,
							}))}
						/>
					</div>

					<div className="flex flex-col md:flex-row w-full gap-6">
						<SelectFormComponent<OrderFormData>
							label="Tipo de faturamento"
							control={form.control}
							name="fkTipoFaturamento"
							disabled={!isEnabledBillingType || isViewOrder || !hasClientSelected}
							onChange={(value) => {
								handleChangeValues({
									fkTipoFaturamento: value,
								})
							}}
							options={billingType?.map((param) => ({
								value: param.idTipoFaturamento.toString(),
								label: param.descricao,
							}))}
						/>

						<SelectFormComponent<OrderFormData>
							label="Tabela de preço"
							control={form.control}
							value={form.watch('fkTabelaPreco') || ''}
							name="fkTabelaPreco"
							disabled={isViewOrder || !hasClientSelected}
							onValueChange={(value) => {
								handleChangeValues({
									fkTabelaPreco: value,
								})
							}}
							options={priceTableList?.map((param) => ({
								value: param.idTabelaPreco.toString(),
								label: param.descricao,
							}))}
						/>

						{isVisibleCommission && (
							<InputFormComponent<OrderFormData>
								label="Porcentagem de comissão"
								control={form.control}
								type="number"
								name="porcComissao"
								disabled={
									!isEnabledCommission || !hasClientSelected || isViewOrder
								}
								onBlur={(e) => {
									const newValue = Number(e.currentTarget.value);
									if (newValue !== form.getValues('porcComissao')) {
										handleChangeValues({
											porcComissao: newValue,
										});
										setIsCalculationComissionOrder(true);
									}
								}}
								onChangeValue={(e) => {
									if (document.activeElement === e.currentTarget) {
										const newValue = Number(e.currentTarget.value);
										if (newValue !== form.getValues('porcComissao')) {
											handleChangeValues({
												porcComissao: newValue,
											});
											setIsCalculationComissionOrder(true);
										}
									}
								}}
							/>
						)}

						<InputFormComponent<OrderFormData>
							label="Num. pedido cliente"
							control={form.control}
							name="nPedidoCliente"
							readOnly
							className='cursor-pointer'
							onClick={() => !isViewOrder && hasClientSelected && setIsOpenModalNPedido(true)}
							disabled={
								!hasClientSelected || isViewOrder
							}
						/>
					</div>

					<div className="flex flex-1 flex-col md:flex-row gap-6">
						{isActiveFieldSelectSeller && (
							<div className="flex flex-1 w-full gap-2">
								<EntityCardComponent
									title='Vendedor'
									descrpition='Clique para selecionar um vendedor'
									onOpen={handleOpenModalSearchSeller}
									entity={jsonOrderForm?.vendedor}
									disabled={isViewOrder || !hasClientSelected}
								/>
							</div>
						)}

						{isVisibleTransport && (
							<div className="flex flex-1 w-full gap-2">
								<EntityCardComponent
									title='Transportadora'
									descrpition='Clique para selecionar uma transportadora'
									onOpen={handleOpenModalSearchTransport}
									entity={jsonOrderForm?.redespacho}
									disabled={isViewOrder || !hasClientSelected}
								/>
							</div>
						)}
					</div>
				</Form>

				<ModalEntityInfiniteScrollComponent />

				<ModalChangeCustomerComponent
					isOpen={isOpenModalChangeCustomerData}
					onConfirm={handleModalConfirmChangeCustomer}
					onCancel={handleModalCancelChangeCustomer}
				/>

				<Dialog open={isOpenModalNPedido} onOpenChange={setIsOpenModalNPedido}>
					<DialogContent>
						<DialogHeader>
							<DialogTitle>Número do pedido cliente</DialogTitle>
						</DialogHeader>
						<div className="py-4">
							<Input
								value={tempNPedido}
								onChange={(e) => setTempNPedido(e.target.value)}
								placeholder="Digite o número do pedido..."
								onKeyDown={(e) => {
									if (e.key === 'Enter') handleConfirmNPedido()
								}}
							/>
						</div>
						<DialogFooter>
							<Button variant="outline" onClick={() => setIsOpenModalNPedido(false)}>Cancelar</Button>
							<Button onClick={handleConfirmNPedido}>Confirmar</Button>
						</DialogFooter>
					</DialogContent>
				</Dialog>
			</div>
		</>
	)
}